module.exports = ".page-banner {\r\n    background: cornflowerblue;\r\n}"